// Paper color palette — single source of truth for JS-side hex values.
// For Tailwind classes, use the token names directly (bg-paper, text-ink, etc.)
// Only use these constants where inline styles or JS config require hex strings.

export const COLORS = {
  sage: '#6B8E6B',
  sageHover: '#5B785B',
  sageLight: '#EDF3ED',
  sageRing: 'rgba(107, 142, 107, 0.15)',
  ink: '#3A3429',
  inkSecondary: '#6B6458',
  inkLabel: '#746D62',
  inkMuted: '#9A9285',
  paper: '#F7F5F0',
  paperLight: '#FCFBF8',
  paperMuted: '#F5F3ED',
  paperInset: '#F0ECE4',
  edge: '#E8E4DC',
  edgeInput: '#E0D9CC',
  warmRed: '#DC5B5B',
  warmAmber: '#D4A243',
  warmBlue: '#5B8DB8',
  warmBrown: '#6B5F4F',
  FORM_DEFAULT_COLOR: '#9A9285',
} as const;
